// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-item {
  padding: 0px 0px;
  margin: 0px 0px;
}
.accordion-item .accordion-header {
  text-align: center;
  padding: 0px 0px;
  background-color: #dbb7bb;
}
.accordion-item .accordion-header .accordion-button {
  background-color: #dbb7bb;
  color: black;
  text-align: left;
  width: 100%;
  padding: 5px 15px;
  display: block;
  border-bottom: 1px solid #dbb7bb;
}
.accordion-item .accordion-header .accordion-button:focus {
  outline: none;
  box-shadow: none;
}
.accordion-item .accordion-header .accordion-button.collapsed {
  border-bottom: 1px solid transparent;
}
.accordion-item .accordion-header .accordion-button::after {
  display: inline-block;
  float: right;
}
.full-screen-height {
  height: 100vh;
}

.main-reports-header {
  background-color: #dbb7bb;
  padding: 4px 0px;
  text-align: center;
}

.main-reports-container {
  border: 1px solid #dbb7bb;
  display: flex;
  flex-direction: row;
  padding: 10px;
  min-height: 0;
}

.progressBar {
  background-color: #f3f3f3;
  border-radius: 3px;
  height: 20px;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressBarFill {
  background-color: #007bff;
  height: 100%;
  transition: width 0.4s ease-in-out;
  position: absolute;
  left: 0;
  z-index: 1;
}

.percentageText {
  z-index: 2;
}

.container-fluid {
  height: 100vh;
}

.full-screen-height {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.main-flex {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.main-reports-container {
  flex-shrink: 0;
}

.tab-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/css/reports/reports.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,eAAA;AACJ;AAAI;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;AAER;AADQ;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AAGZ;AAFY;EACI,aAAA;EACA,gBAAA;AAIhB;AAFY;EACI,oCAAA;AAIhB;AAFY;EACI,qBAAA;EACA,YAAA;AAIhB;AAGA;EACI,aAAA;AADJ;;AAGA;EACI,yBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,SAAA;EACA,aAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAAJ;;AAGE;EACE,cAAA;AAAJ;;AAGE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAAJ","sourcesContent":[".accordion-item {\n    padding: 0px 0px;\n    margin: 0px 0px;\n    .accordion-header {\n        text-align: center;\n        padding: 0px 0px;\n        background-color: #dbb7bb;\n        .accordion-button {\n            background-color: #dbb7bb;\n            color: black;\n            text-align: left;\n            width: 100%;\n            padding: 5px 15px;\n            display: block;\n            border-bottom: 1px solid #dbb7bb;\n            &:focus {\n                outline: none;\n                box-shadow: none;\n            }\n            &.collapsed {\n                border-bottom: 1px solid transparent;\n            }\n            &::after {\n                display: inline-block;\n                float: right;\n            }\n        }\n    }\n    .accordion-collapse {}\n}\n\n.full-screen-height {\n    height: 100vh;\n}\n.main-reports-header {\n    background-color: #dbb7bb;\n    padding: 4px 0px;\n    text-align: center;\n}\n\n.main-reports-container {\n    border: 1px solid #dbb7bb;\n    display: flex;\n    flex-direction: row;\n    padding: 10px;\n    min-height: 0;\n}\n\n.progressBar {\n    background-color: #f3f3f3;\n    border-radius: 3px;\n    height: 20px;\n    width: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.progressBarFill {\n    background-color: #007bff; \n    height: 100%;\n    transition: width 0.4s ease-in-out;\n    position: absolute;\n    left: 0;\n    z-index: 1;\n}\n\n.percentageText {\n    z-index: 2;\n}\n\n.container-fluid {\n    height: 100vh; \n}\n\n.full-screen-height {\n    flex: 1; // Grow to fill its parent\n    display: flex;\n    flex-direction: column; // Set direction to column so its children can be controlled vertically\n}\n\n.main-flex {\n    display: flex;\n    flex-direction: column;\n    height: 100%; // Assuming your parent container has a defined height\n  }\n  \n  .main-reports-container {\n    flex-shrink: 0; // This ensures that this div won't shrink smaller than its content\n  }\n\n  .tab-container {\n    flex-grow: 1; // This ensures that this div takes up the remaining space\n    display: flex;\n    flex-direction: column;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
